
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return /^(140|1889|6215|9169)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
